// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchSellersIfNeeded } from '../../../redux/modules/seller';
import { recordAnalyticsForConsignmentsPageView } from '../../../redux/modules/analytics';
import { sleep } from '../../../utils/sleep';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const sellerId = Number(params.sellerId);
    const promises = [];
    if (sellerId) {
        promises.push(dispatch(fetchSellersIfNeeded([sellerId])));
    } else {
        promises.push(sleep(1500));
    }
    return Promise.all(promises).then(() => {
        return dispatch(recordAnalyticsForConsignmentsPageView());
    });
};
